export default {
  'pages.applicationFeedback.factoryIssue': '软件工厂事项',
  'pages.applicationFeedback.factoryIssueNotAdded': '未添加为事项',
  'pages.applicationFeedback.factoryIssueAdding': '添加中',
  'pages.applicationFeedback.factoryIssueFailed': '添加失败',
  'pages.applicationFeedback.factoryIssuePartiallyAdded':
    '事项已创建，关联未完成',
  'pages.applicationFeedback.factoryIssueDeleted': '关联事项已删除',
  'pages.applicationFeedback.readdToSoftwareFactory': '重新添加到软件工厂',
  'pages.applicationFeedback.factoryIssueId': '事项标识',

  'pages.applicationFeedback.organizationFilter': '筛选组织',
  'pages.applicationFeedback.retrySoftwareFactory': '重试添加到软件工厂',
  'pages.applicationFeedback.title': '应用反馈',
  'pages.applicationFeedback.feedback': '反馈内容',
  'pages.applicationFeedback.searchPlaceholder': '搜索标题或内容',
  'pages.applicationFeedback.type': '反馈类型',
  'pages.applicationFeedback.status': '处理状态',
  'pages.applicationFeedback.priority': '优先级',
  'pages.applicationFeedback.application': '应用',
  'pages.applicationFeedback.applications': '应用列表',
  'pages.applicationFeedback.allFeedback': '全部反馈',
  'pages.applicationFeedback.pluginApplication': '插件应用',
  'pages.applicationFeedback.pcApplication': 'PC普通应用',
  'pages.applicationFeedback.searchApplications': '搜索应用名称或标识',
  'pages.applicationFeedback.refreshApplications': '刷新应用列表',
  'pages.applicationFeedback.noApplications': '暂无有反馈记录的应用',
  'pages.applicationFeedback.noFeedback': '暂无反馈',
  'pages.applicationFeedback.applicationsUnavailable': '应用列表加载失败',
  'pages.applicationFeedback.unknownApplication': '未关联应用',
  'pages.applicationFeedback.unknownName': '未知',
  'pages.applicationFeedback.unknownSubmitter': '未知提交人',
  'pages.applicationFeedback.tenant': '租户',
  'pages.applicationFeedback.tenantFilter': '筛选租户',
  'pages.applicationFeedback.submitter': '提交人',
  'pages.applicationFeedback.operator': '平台处理人',
  'pages.applicationFeedback.createdAt': '提交时间',
  'pages.applicationFeedback.lastActivity': '最近更新',
  'pages.applicationFeedback.contact': '联系方式',
  'pages.applicationFeedback.pageUrl': '反馈页面',
  'pages.applicationFeedback.viewScreenshot': '查看截图',
  'pages.applicationFeedback.attachments': '附件',
  'pages.applicationFeedback.previewAttachment': '预览附件',
  'pages.applicationFeedback.downloadAttachment': '下载附件',
  'pages.applicationFeedback.popupBlocked':
    '浏览器阻止了附件页面，请允许弹出窗口后重试',
  'pages.applicationFeedback.actions': '操作',
  'pages.applicationFeedback.detail': '详情',
  'pages.applicationFeedback.addToSoftwareFactory': '添加到软件工厂',
  'pages.applicationFeedback.addedToSoftwareFactory': '已添加到软件工厂',
  'pages.applicationFeedback.addToSoftwareFactorySuccess': '已添加到软件工厂',
  'pages.applicationFeedback.softwareFactoryProjectMissing':
    '暂无项目信息，无法创建事务',
  'pages.applicationFeedback.replies': '回复记录',
  'pages.applicationFeedback.activity': '处理记录',
  'pages.applicationFeedback.noReplies': '暂无回复',
  'pages.applicationFeedback.replyPlaceholder': '输入回复内容',
  'pages.applicationFeedback.replyRequired': '请输入回复内容',
  'pages.applicationFeedback.sendReply': '发送回复',
  'pages.applicationFeedback.replySuccess': '回复已发送',
  'pages.applicationFeedback.updateSuccess': '已更新反馈',
  'pages.applicationFeedback.refresh': '刷新',
  'pages.applicationFeedback.empty': '暂无应用反馈',
  'pages.applicationFeedback.totalCount': '共 {count} 条',
  'pages.applicationFeedback.detailUnavailable': '无法加载反馈详情',
  'pages.applicationFeedback.type.bug': '问题反馈',
  'pages.applicationFeedback.type.feature': '功能建议',
  'pages.applicationFeedback.type.optimization': '体验优化',
  'pages.applicationFeedback.type.other': '其他',
  'pages.applicationFeedback.status.pending': '待处理',
  'pages.applicationFeedback.status.processing': '处理中',
  'pages.applicationFeedback.status.resolved': '已解决',
  'pages.applicationFeedback.status.closed': '已关闭',
  'pages.applicationFeedback.status.withdrawn': '已撤回',
  'pages.applicationFeedback.priority.low': '低',
  'pages.applicationFeedback.priority.medium': '中',
  'pages.applicationFeedback.priority.high': '高',
};
